import { tagsApi } from "../view/tagsService";

export const deleteTags = tagsApi.injectEndpoints({
  endpoints: (builder) => ({
    deleteTags: builder.mutation({
      query: (id) => {
        return {
          url: `/v1/api/tag/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "tags", id: "LIST" }],
    }),
  }),
});

export const { useDeleteTagsMutation } = deleteTags;
